export default Object.freeze({
    MaximumParcelWeightInGrams: 30000
});